export default "__VITE_ASSET__DnE_slrQ__"